module.exports = __webpack_public_path__ + "static/essays--lectures-9527b7d09886bca4d47ed02f9d3153de.jpg";